import { useReviewPromptStore } from '@/stores/review-prompt';
import { useMediaQuery } from '@uidotdev/usehooks';
import { ReviewPromptSheet } from '../review-prompt-sheet';
import { DesktopNavigation } from './desktop-navigation';
import { MobileNavigation } from './mobile-navigation';

function AppLayout() {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const showReviewSheet = useReviewPromptStore((s) => s.showReviewSheet);
  const setShowReviewSheet = useReviewPromptStore((s) => s.setShowReviewSheet);

  const content = isMobile ? <MobileNavigation /> : <DesktopNavigation />;

  return (
    <>
      {content}
      <ReviewPromptSheet
        open={showReviewSheet}
        onOpenChange={setShowReviewSheet}
      />
    </>
  );
}

export { AppLayout };
